module.exports = __webpack_public_path__ + "img/logo-mobiplus-preto.123be542.png";